module.exports = __webpack_public_path__ + "static/waking-up-b6e669bdc7b64d935b860119b1a0b5d2.jpg";